import React from 'react';
import '../../css/home/Features.css';

const Features = () => {
  const features = [
    {
      emoji: "⚙️",
      title: "We Own the Pipeline",
      description: "Recruiting, training, tracking, managing. We do it all. You stay focused on growth, we handle the student engine."
    },
    {
      emoji: "⚡",
      title: "Faster Than In-House",
      description: "Our systems are pre-built. Our network is primed. We can launch programs in weeks, not months."
    },
    {
      emoji: "🤝",
      title: "Trust Built On Campus",
      description: "Our student teams live the culture, speak the language, and create authentic trust with their peers — not forced scripts."
    },
    {
      emoji: "🎓",
      title: "Vetted Student Network",
      description: "We've built a trusted network across 145+ campuses with 2,500+ fully onboarded students ready to activate your brand."
    }
  ];

  return (
    <section className="features-section" id="whyromulus">
      <h2 className="section-heading">Why Us?</h2>
      <div className="features-container">
        {features.map((feature, index) => (
          <div className="feature-card" key={index}>
            <div className="feature-emoji">{feature.emoji}</div>
            <div className="feature-content">
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Features;